import { sanitizeSVGTree } from '@/utils/svg-kit';

// cspell:ignore parsererror

/**
 * 使用 Text Render 既有的严格策略解析并清洗内部 SVG 素材。
 *
 * 本函数只共享 parse 与 sanitize。Highlight 和花字对 viewBox 的校验存在有意差异，仍由各自调用方负责。
 *
 * @param svgText - 已加载完成的 SVG 文本。
 * @returns 解析并严格清洗后的 SVG 根节点；文档无效或根节点不是 SVG 时返回 null。
 */
export const parseStrictSVG = (svgText: string): SVGSVGElement | null => {
    const parsedDocument = new DOMParser().parseFromString(svgText, 'image/svg+xml');
    if (parsedDocument.querySelector('parsererror') || parsedDocument.documentElement.tagName.toLowerCase() !== 'svg') {
        return null;
    }
    return sanitizeSVGTree(parsedDocument.documentElement as unknown as SVGSVGElement);
};
